import { Trans } from "@lingui/macro";
import { ProjectTypeEnum } from "@src/__generated__/urql-graphql";
import { ButtonLink } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { useStore as useAppStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useStore } from "./Store";

export const ButtonBudgetSettings = observer(function ButtonBudgetSettings() {
  const { workspaceStore } = useAppStore();
  const store = useStore();

  if (store.project?.type === ProjectTypeEnum.TimeMaterials) return null;

  return (
    <ButtonLink
      href={{
        pathname: workspaceStore.settings?.moduleSettings.budgetovac
          ? `/projects/budgets`
          : `/projects/budget`,
        query: { id: store.project?.id },
      }}
      variant="outline"
      colorScheme="grey"
      leftIcon={<Icon name="settings-01" />}
    >
      <Trans>Budget settings</Trans>
    </ButtonLink>
  );
});
